import { Link } from 'react-router';

export function NotFoundPage() {
    return (
        <section className="flex flex-1 flex-col items-center justify-center gap-5 py-24 text-center">
            <p className="text-focus text-xs font-semibold tracking-[0.35em] uppercase">
                404
            </p>
            <h1 className="text-3xl font-bold tracking-tight uppercase sm:text-4xl">
                Nothing breaking here
            </h1>
            <p className="text-text-secondary max-w-prose">
                That page does not exist. Paddle back out.
            </p>
            <Link
                to="/"
                className="text-focus mt-2 underline underline-offset-4 hover:text-focus/80"
            >
                Back to the beach
            </Link>
        </section>
    );
}
